import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useStore } from "./state";
import shallow from "zustand/shallow";
import LocationDetail from "./detail";

export default function LocationModal(props) {
  const { active_location, chart_range, setChartRange } = useStore(
    (state) => ({
      active_location: state.active_location,
      location_data: state.location_data,
      chart_range: state.chart_range,
      setChartRange: state.setChartRange,
    }),
    shallow
  );

  console.log(active_location);
  return (
    <Modal
      show={props.modalShow}
      fullscreen={true}
      onHide={() => props.setModalShow(false)}
    >
      <Modal.Header closeButton className="detail-modal" closeVariant={"white"}>
        <Modal.Title>{active_location.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="detail-modal">
        <LocationDetail />
      </Modal.Body>
    </Modal>
  );
}
